/** Keep in sync with nfc-backend/src/constants/featurePermissions.ts */

export const FEATURE_PERMISSION_KEYS = {
  BALANCE_TRANSFER: "balance_transfer",
} as const;

export type FeaturePermissionKey =
  (typeof FEATURE_PERMISSION_KEYS)[keyof typeof FEATURE_PERMISSION_KEYS];

export type FeaturePermissionMeta = {
  key: FeaturePermissionKey;
  label: string;
  description: string;
  /** Module this extra belongs to (for admin UI grouping) */
  module: string;
  moduleLabel: string;
  assignableToRoles: string[];
};

export const FEATURE_PERMISSION_CATALOG: FeaturePermissionMeta[] = [
  {
    key: FEATURE_PERMISSION_KEYS.BALANCE_TRANSFER,
    label: "Balance transfer",
    description: "Transfer balance between cards of the same customer",
    module: "nfc_cards",
    moduleLabel: "NFC Cards",
    assignableToRoles: [],
  },
];

export const getAssignableFeaturesForRole = (role: string): FeaturePermissionMeta[] => {
  const normalized = role?.toUpperCase();
  return FEATURE_PERMISSION_CATALOG.filter((f) =>
    f.assignableToRoles.includes(normalized)
  );
};

export const hasFeatureKey = (
  effectiveFeatures: string[] | undefined,
  key: FeaturePermissionKey
): boolean => Boolean(effectiveFeatures?.includes(key));
